import { DecimalFormatterService } from './../models/decimal-formatter.service';
import { Pipe, PipeTransform } from "@angular/core";

const PADDING = "000000";

@Pipe({ name: "decimalFormatter" })
export class DecimalFormatterPipe implements PipeTransform {


  constructor(private decimalFormatterService: DecimalFormatterService) {

  }

  //transform(value: number | string, fractionSize: number = 2): string {
  transform(value: number | string, allowGrouping: boolean = false): string {
    return this.decimalFormatterService.transform(value, allowGrouping);
  }

  // parse(value: string, fractionSize: number = 2): string {
  //   return this.decimalFormatterService.parse(value, fractionSize);
  // }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/pipe/decimal-formatter.pipe.ts